import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import * as moment from 'moment';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { PERMISSION } from '../../../analytics-core/interfaces/permission.interface';
import * as _ from 'underscore';

@Component({
	selector: 'app-single-stat',
	templateUrl: './single-stat.component.html',
	styleUrls: ['./single-stat.component.css']
})
export class SingleStatComponent implements OnInit, WidgetCore, OnDestroy {
	singleStatData: any = {
		stat: ' ',
		statPercentage: ' '
	};
	public overviewSingleStatData = [];
	public enabledMetrics;
	public key: string;
	public groupby: string;
	@Input() sectiontitle: string;
	@Input() columnsconfig: any;
	@Input() iscustomendpoint: any;
	@Input() legend: any;
	@Input() uniqueoverwriteid: string;
	islegend: boolean = false;
	public sectionclass: string;
	public tooltipinfo: string;
	public range;
	title: string;
	color: any;
	public showLoad = true;
	public tooltipOptions = {
		position: 'top',
		animation: 'fade',
		arrow: true,
		duration: 750,
		scale: 'big',
		dynamicTitle: true
	};
	public reloadSubscription;
	public hasData: boolean;
	public widgetDataSubscription;
	public enabled: boolean;
	public avgpos = ['Avg. Position', 'Average Position', 'Avg Position'];
	tempEnabledMetrics: any;
	isGoliveNotStarted: boolean;
	isCutoffDate: boolean;
	public columns: any;
	public youtubeViewsPermission: boolean;
	public youtubeViewsPermissionCheck: object = { permission: { flags: ['hasYoutubeViews'] } };
	public tempLegend: any;
	public isR104: boolean = false;

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.enabled = false;
			this.tempEnabledMetrics = true;
			if (this.avgpos.includes(this.sectiontitle)) {
				this.checkForVisibilityPermissions();
			}
			if (this.tempEnabledMetrics) {
				this.requestData();
			}
		});
	}
	ngOnInit() {
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.enabled = false;
		this.legend = JSON.parse(decodeURI(this.legend));
		if (this.legend?.length > 0) {
			this.legend = _.filter(this.legend, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
		this.tempEnabledMetrics = true;
		if (this.columnsconfig) {
			this.columns = JSON.parse(decodeURI(this.columnsconfig));
		}
		if (this.avgpos.includes(this.sectiontitle)) {
			this.checkForVisibilityPermissions();
		}
		if (this.tempEnabledMetrics) {
			this.requestData();
		}
		this.youtubeViewsPermission = this.analyticsDataModel.checkComponentForPermission(this.youtubeViewsPermissionCheck);
	}
	ngOnDestroy() {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	requestData() {
		this.hasData = true;
		this.showLoad = true;
		if (this.iscustomendpoint == 'true') {
			this.widgetDataSubscription = this.analyticsService
				.processCustomServiceRequest(this.key, null, null, null, null, this.uniqueoverwriteid)
				.subscribe((res: any) => {
					this.showLoad = false;
					if (res.success) {
						this.hasData = true;
						this.processResponseData(res.data);
					} else {
						this.hasData = false;
					}
				});
		} else {
			this.widgetDataSubscription = this.analyticsService
				.processWidgetRequest(this.key, this.columns, null, this.uniqueoverwriteid)
				.subscribe((res: any) => {
					this.showLoad = false;
					if (res.success) {
						this.hasData = true;
						this.processResponseData(res.data);
					} else {
						this.hasData = false;
					}
				});
		}
	}

	processResponseData(response: any) {
		this.islegend = this.legend?.length > 0 ? true : false;
		if (!this.islegend) {
			// check for permission
			const userPermissions: any[] = this.analyticsDataModel.setupData.permissions;
			if (this.groupby == 'offline_visits') {
				if (_.indexOf(userPermissions, PERMISSION[PERMISSION.hasOfflineVisits]) == -1) {
					this.enabled = false;
				} else {
					this.enabled = true;
				}
			} else {
				this.enabled = true;
			}

			var stat;
			if (this.groupby == 'avg_position') {
				stat = UtilityService.isUndefinedOrNull(response[0][this.groupby])
					? 0
					: parseFloat(response[0][this.groupby]).toFixed(2);
			} else {
				stat = UtilityService.isUndefinedOrNull(response[0][this.groupby]) ? 0 : response[0][this.groupby];
			}
			let statPercentage = UtilityService.isUndefinedOrNull(response[0][this.groupby + '_percent'])
				? null
				: response[0][this.groupby + '_percent'] === ''
				? ' '
				: parseFloat(response[0][this.groupby + '_percent']).toFixed(2) + '%';

			statPercentage =
				statPercentage == null || statPercentage == ' '
					? UtilityService.isUndefinedOrNull(response[0][this.groupby + '_rate'])
						? null
						: response[0][this.groupby + '_rate'] === ''
						? ' '
						: parseFloat(response[0][this.groupby + '_rate']).toFixed(2) + '%'
					: statPercentage;

			if (!stat || stat === '0') {
				this.hasData = false;
			}
			this.singleStatData = {
				stat: stat,
				statPercentage: statPercentage
			};
		} else {
			this.overviewSingleStatData = [];
			const dateSet = {
				depricatedDate: this.analyticsDataModel.depricatedDate,
				endDate: this.analyticsDataModel.endDate,
				goLiveDate: this.analyticsDataModel.goLiveDate,
				startDate: this.analyticsDataModel.startDate
			};
			this.tempLegend = UtilityService.checkForVisibilityPermissions(this.legend, dateSet);
			for (let i = 0; i < this.tempLegend.length; i++) {
				// check for permission
				const userPermissions: any[] = this.analyticsDataModel.setupData.permissions;
				if (this.tempLegend[i].value == 'offline_visits') {
					if (_.indexOf(userPermissions, PERMISSION[PERMISSION.hasOfflineVisits]) == -1) {
						this.enabled = false;
					} else {
						this.enabled = true;
					}
				} else {
					this.enabled = true;
				}

				var stat;
				if (this.tempLegend[i].value == 'avg_position') {
					stat = UtilityService.isUndefinedOrNull(response[0][this.tempLegend[i].value])
						? 0
						: parseFloat(response[0][this.tempLegend[i].value]).toFixed(2);
				} else {
					stat = UtilityService.isUndefinedOrNull(response[0][this.tempLegend[i].value])
						? 0
						: response[0][this.tempLegend[i].value];
				}
				let statPercentage = UtilityService.isUndefinedOrNull(response[0][this.tempLegend[i].value + '_percent'])
					? null
					: response[0][this.tempLegend[i].value + '_percent'] === ''
					? ' '
					: parseFloat(response[0][this.tempLegend[i].value + '_percent']).toFixed(2) + '%';

				statPercentage =
					statPercentage == null || statPercentage == ' '
						? UtilityService.isUndefinedOrNull(response[0][this.tempLegend[i].value + '_rate'])
							? null
							: response[0][this.tempLegend[i].value + '_rate'] === ''
							? ' '
							: parseFloat(response[0][this.tempLegend[i].value + '_rate']).toFixed(2) + '%'
						: statPercentage;

				this.overviewSingleStatData.push({
					statName: this.tempLegend[i].displayName,
					stat: stat,
					statPercentage: statPercentage,
					statColor: this.tempLegend[i].color,
					tooltipInfo: this.tempLegend[i].tooltipInfo,
					hasData: !stat || stat === '0' ? false : this.hasData
				});
			}
		}
	}

	checkForVisibilityPermissions() {
		const isCutoffDate =
			moment(this.analyticsDataModel.startDate).isAfter(this.analyticsDataModel.depricatedDate) ||
			moment(this.analyticsDataModel.startDate).isSame(this.analyticsDataModel.depricatedDate);
		if (isCutoffDate) {
			this.enabled = false;
			this.tempEnabledMetrics = false;
		}
	}
}
